import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

// Vue.prototype.$axios = axios
Vue.use(VueAxios, axios)

/*
  // https://gist.github.com/mkjiau/650013a99c341c9f23ca00ccb213db1c
  let isAlreadyFetchingAccessToken = false
  let subscribers = []
  function onAccessTokenFetched (access_token) {
    subscribers = subscribers.filter(callback => callback(access_token))
  }
  function addSubscriber (callback) {
    subscribers.push(callback)
  }
  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const {
        config,
        response: { status }
      } = error
      const originalRequest = config

      if (status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch(fetchAccessToken()).then(access_token => {
            isAlreadyFetchingAccessToken = false
            onAccessTokenFetched(access_token)
          })
        }

        const retryOriginalRequest = new Promise(resolve => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = 'Bearer ' + access_token
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    }
  ) */
